"use client";
export { Heading as default } from "../../../_Builtin/Typography";
